import { render, staticRenderFns } from "./halo-effect.vue?vue&type=template&id=6067e708&scoped=true"
import script from "./halo-effect.vue?vue&type=script&lang=js"
export * from "./halo-effect.vue?vue&type=script&lang=js"
import style0 from "./halo-effect.vue?vue&type=style&index=0&id=6067e708&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6067e708",
  null
  
)

export default component.exports